<template>
  <a-modal
    title="操作"
    style="top: 20px"
    :width="800"
    v-model="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    :maskClosable="false"
    :footer="false"
  >
    <div class="table-page-search-wrapper" >
      <a-form-item style="display: none" >
        <a-input v-decorator="['id']" />
      </a-form-item>

      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form">
          <label class="threela">补价信息:</label>
          <a-row :gutter="7">
            <a-col :span="7">
              <a-form-item label="企业名称">
                <a-input v-decorator="['enterpriseSysName']" disabled="disabled" />
              </a-form-item>
            </a-col>
            <a-col :span="7">
              <a-form-item label="企业申请价格">
                <a-input v-decorator="['enterprisePrice']" disabled="disabled" />
              </a-form-item>
            </a-col>
            <a-col :span="7">
              <a-form-item label="师傅申请价格">
                <a-input v-decorator="['price']" disabled="disabled" />
              </a-form-item>
            </a-col>
            <a-col :span="7">
              <a-form-item label="补价类型">
                <a-input v-decorator="['types']" disabled="disabled" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="申请时间">
                <a-input v-decorator="['createTime']" disabled="disabled"/>
              </a-form-item>
            </a-col>
          </a-row>

           <div style="margin-top: 40px">
            <label class="threela">图&nbsp;&nbsp;&nbsp;&nbsp;片:</label>
            <div style="display: flex; flex-wrap: wrap; margin-left: 6%">
              <div v-for="type in fileListMaster"
                style="width: 200px; height: 200px; border: 1px solid #ccc; margin: 10px; text-align: center"
              >
                <a :href="process + '/dfs/download?fileName=' + type.url + '&token=' + headers.token" download>
                  <img
                    style="max-width: 100%; max-height: 100%"
                    :src="'https://lockan.obs.cn-east-3.myhuaweicloud.com/' + type.url"
                  />
                </a>
              </div>
            </div>
          </div>

          <div style="margin-top: 40px">
            <label class="threela">师傅信息:</label>
            <a-row :gutter="7" style="margin-top: 10px">
              <a-col :span="11">
                <a-form-item label="师傅姓名">
                  <a-input v-decorator="['workName']" disabled="disabled" />
                </a-form-item>
              </a-col>
              <a-col :span="11">
                <a-form-item label="师傅电话">
                  <a-input v-decorator="['workPhone']" disabled="disabled" />
                </a-form-item>
              </a-col>        
            </a-row>
             <a-row :gutter="7" style="margin-top: 10px">            
              <a-col :span="22">
                <a-form-item label="师傅地址">
                  <a-input v-decorator="['masterAdress']" disabled="disabled" />
                </a-form-item>
              </a-col>
            </a-row>
          </div>
 

          <div style="margin-top: 40px">
            <label class="threela">客户信息:</label>
            <a-row :gutter="7" style="margin-top: 10px">
              <a-col :span="11">
                <a-form-item label="客户姓名">
                  <a-input v-decorator="['clientName']" disabled="disabled"/>
                </a-form-item>
              </a-col>
              <a-col :span="11">
                <a-form-item label="客户电话">
                  <a-input v-decorator="['clientPhone']" disabled="disabled"/>
                </a-form-item>
              </a-col>  
            </a-row>

            <a-row :gutter="7" style="margin-top: 10px">
              <a-col :span="22">
                <a-form-item label="客户地址">
                  <a-input v-decorator="['clientAddress']" disabled="disabled" />
                </a-form-item>
              </a-col>
            </a-row>
          </div>

          <div style="margin-top: 40px">
            <a-row :gutter="16" style="margin-bottom: 60px">
              <a-col :span="22">
                <a-form-item label="反馈信息" style="width: 100%; margin-bottom: 20px">
                  <a-textarea v-decorator="['feeback']" disabled="disabled" />
                </a-form-item>
              </a-col>
            </a-row>
          </div>

          <div></div>
        </a-form>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { queryOrderGet } from '@/api/order/increaseAuditList'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import pick from 'lodash.pick'
export default {
  name: 'increaseAuditInfo',
  props: {},
  components: {},
  data() {
    return {
      process: process.env.VUE_APP_API_BASE_URL,
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      fileListMaster: [],
      clientInfoPics: [],
      data: '',
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      mdl: {},
      form: this.$form.createForm(this),
    }
  },
  beforeCreate() {},
  created() {},
  methods: {
    edit(record) {
      console.log('record', record)
      this.fileListMaster = []
      if (null != record.imgUrl) {
        let arr = record.imgUrl.split(',')
        for (var key of arr) {
          this.fileListMaster.push({
            url: key,
          })
          console.log(key)
        }
      }

      this.mdl = Object.assign(record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.mdl,
            'id',
            'orderId',
            'orderNo',
            'price',
            'imgUrl',
            'masterAdress',
            'remark',
            'types',
            'workName',
            'workPhone',
            'clientPhone',
            'clientName',
            'clientAddress',
            'createTime',
            'feeback',
            'enterpriseSysName',
            'enterprisePrice'
          )
        )
      })
    },

    handleSubmit(e) {
      this.visible = false
    },
  },

  watch: {},
}
</script>
<style scoped>
.disEvents {
  pointer-events: none;
}
</style>
